import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlaylistRemoveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"playlist_remove"}/>
}
